/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Connection_Error_DescriptionInputs */



/**
* | output |
* | --- |
* | "We couldn't reach the server to restore your session. You're still signed in — this is a temporary connection problem, not a sign-out. Please try again in a ..." |
*
* @param {Auth_Connection_Error_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_connection_error_description = /** @type {((inputs?: Auth_Connection_Error_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Connection_Error_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wir konnten den Server nicht erreichen, um deine Sitzung wiederherzustellen. Du bist weiterhin angemeldet – dies ist ein vorübergehendes Verbindungsproblem, keine Abmeldung. Bitte versuche es gleich erneut.")
	return /** @type {LocalizedString} */ ("We couldn't reach the server to restore your session. You're still signed in — this is a temporary connection problem, not a sign-out. Please try again in a moment.")
});